import { FC, useState, useEffect } from "react";
import {
	Box,
	Divider,
	Paper,
	Typography,
} from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useSelector } from "react-redux";
import { request } from "../request";
import { ESRState } from "../types/data";
import getBackendURL from "@/api/api";

interface Manual {
	name: string;
	url: string;
}

export const HelpPage: FC = () => {
	const user = useSelector((state: ESRState) => state.current_user);
	const [manualsCount, setManualCount] = useState(0);
	const [manuals, setUserManuals] = useState<Manual[]>([]);
	useEffect(() => {
		if (user) {
			const url = getBackendURL("/esr/fetch_manuals/");
			request.get(url).then(({data}) => {
				setUserManuals(data.manuals);
				setManualCount(data.num_manuals);
			});
		}
	}, []);

	return (
		<>
			<Box sx={{ px: "300px", py: "60px" }}>
				<Typography fontSize={24} fontWeight={700}>
					User Help
				</Typography>

				<Divider sx={{ my: "40px" }} />

				<Typography mt="40px" fontSize={16} fontWeight={700}>
					Manuals ({manualsCount})
				</Typography>

							<Box mt={2}>
    {manuals.length === 0 ? (
        <Typography color="text.secondary">
            No manuals available.
        </Typography>
    ) : (
        manuals.map((manual) => (
            <Paper
                key={manual.name}
                elevation={1}
                sx={{
                    mb: 1,
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    cursor: "pointer",
                    "&:hover": {
                        backgroundColor: "grey.100",
                    },
                }}
                onClick={() => window.open(manual.url, "_blank")}
            >
                <DescriptionOutlinedIcon
                    color="primary"
                    fontSize="large"
                />

                <Typography>
                    {manual.name}
                </Typography>
            </Paper>
        ))
    )}
</Box>

			</Box>
		</>
	);
};
